import axios from 'axios';

async function ObtenerAgenteComercial(prmCodigoAgente: string, prmIdComercial: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_comercial"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_comercial": prmIdComercial,
            "comercial": prmCodigoAgente
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerAgenteComercial;